export const gridItems = [
  {
    title: "Khu Rừng Kỳ Diệu | Official Trailer",
    youtube: "_vxH0DywiXE",
    url: "gallery/1/khu_rung_ky_dieu.jpg",
  },
  {
    title: "Ở Đây Có Nắng - Movie",
    youtube: "9aJ26mDMmfg",
    url: "gallery/1/o_day_co_nang.jpg",
  },
  {
    title: "Đường Về Nhà của Hai",
    youtube: "9tp-VyflaPo",
    url: "gallery/1/duong_ve_nha_cua_hai.jpg",
  },
  {
    title: "Tài Ký Food",
    youtube: "RxMDvPFzbs8",
    url: "gallery/1/tai_ky_food.jpg",
  },
  {
    title: "SUNLIGHT",
    youtube: "fn2qeir-A28",
    url: "gallery/1/2.jpg",
  },
  {
    title: "YHL",
    vimeo: "374631286",
    url: "gallery/1/yhl.jpg",
  },
  {
    title: "DCOM",
    youtube: "jxv5sxJIvEw",
    url: "gallery/1/dcom.jpg",
  },
  {
    title: "Short Film 200K",
    youtube: "B5K0FKRd7vY",
    url: "gallery/1/s200k.jpg",
  },
  {
    title: "Short film Giải cứu trùm cuối",
    youtube: "eknZ2C_sqp0",
    url: "gallery/1/6.jpg",
  },
  {
    title: "ĐƯỜNG ĐUA",
    youtube: "cD8Ka5bCJss",
    url: "gallery/1/duong_dua.jpg",
  },
  {
    title: "Short Film Chị Vợ Nóng Bỏng",
    vimeo: "456024836",
    url: "gallery/1/22.jpg",
  },
  {
    title: "TVC sunlight",
    youtube: "IFavAVDImos",
    url: "gallery/1/7.jpg",
  },
  {
    title: "Hứa Minh Đạt vs Quạt hút Panasonic",
    youtube: "h3YnU5lzdqI",
    url: "gallery/1/29.jpg",
  },
  {
    title: 'Thẻ Nhớ Sandisk',
    youtube: "bIu6BjuR6-w",
    url: "gallery/1/sandisk.jpg",
  },
  {
    title: 'Tiki "Tự Nhiên Cái Tết"',
    youtube: "1Ip-MCPTmP0",
    url: "gallery/1/10.jpg",
  },
  {
    title: "LAZADA - LAZZIE",
    youtube: "JjogtbSERLI",
    url: "gallery/1/lazada.jpg",
  },
  {
    title: "Short Film Cowboys Sai Gon",
    vimeo: "416343974",
    url: "gallery/1/4.jpg",
  },
  {
    title: "Sám Hối Movie - Phó Đạo Diễn",
    youtube: "wwOZzyBDJjM",
    url: "gallery/1/sam_hoi.jpg",
  },
  {
    title: 'Sơn Hà',
    youtube: "qlv790Omf9w",
    url: "gallery/1/son_ha.jpg",
  },
  {
    title: "CNG VIETNAM",
    youtube: "vV4rDCsXLk8",
    url: "gallery/1/31.jpg",
  },
  {
    title: "Giải Mã Bùa Yêu - Movie",
    youtube: "VHjMEOrA0Rc",
    url: "gallery/1/16.jpg",
  },
  {
    title: "TVC Taky Food",
    vimeo: "295529588",
    url: "gallery/1/8.jpg",
  },
  {
    title: "Comfort",
    youtube: "S-FcTPIJZFI",
    url: "gallery/1/12.jpg",
  },
  {
    title: 'Devose Care',
    youtube: "gvfQLAbLv_c",
    url: "gallery/1/devose_care.jpg"
  },
  {
    title: "Viral Gas South",
    vimeo: "724346468",
    url: "gallery/1/viral-gas-south.jpg",
  },
  {
    title: "SCG Thailand",
    vimeo: "289667705",
    url: "gallery/1/scg_thailand.jpg",
  },
  {
    title: "Viral Kingsport",
    youtube: "-qOvzwuGVLQ",
    url: "gallery/1/13.jpg",
  },
  {
    title: 'AIG',
    youtube: "-BCJb9fmjbg",
    url: "gallery/1/ingredients_for_better_life.jpg"
  },
  {
    title: "Bếp Của Mẹ - TV Series on K+",
    vimeo: "278866376",
    url: "gallery/1/11.jpg",
  },
  {
    title: "TVC Super Humic",
    youtube: "CXM85yfhc-w",
    url: "gallery/1/17.jpg",
  },
  {
    title: "Trà Vinh province",
    youtube: "VLwsAq-KSqM",
    url: "gallery/1/30.jpg",
  },
  {
    title: "Lotte Kids FC 2016 - Reality show on VTV3",
    vimeo: "278867094",
    url: "gallery/1/14.jpg",
  },
  {
    title: "TVC larue",
    youtube: "SgX8eHT6uM4",
    url: "gallery/1/15.jpg",
  },
  {
    title: "MV Tình cờ -  Kỳ Phương Uyên",
    youtube: "j5xmgdN_sFQ",
    url: "gallery/1/21.jpg",
  },
  {
    title: "MV Thấm Thía",
    youtube: "fiUA-GXSNTk",
    url: "gallery/1/26.jpg",
  },
  {
    title: "MV Yêu Là Phải Thương",
    youtube: "GVfv3-mYFvQ",
    url: "gallery/1/yeu-la-phai-thuong.jpg",
  },
];
